import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/ims/stock-return/{id}/approve`。body 含 updatedAt。 */
export async function approveStockReturn(id, payload = {}) {
  const { data: raw } = await request.post(
    `/ims/stock-return/${id}/approve`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
